/* eslint-disable react/no-unknown-property */
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, Box, Image, Heading } from 'theme-ui'
import { useRouter } from 'next/router'
import { NavBar } from '/components/Korea/NavBar'
import redirectToPage from '/lib/redirect'
import styles from './styles'

const Header = ({ sideMenu, layout, ...props }) => {
  const router = useRouter()
  const { locale } = props

  const defaultImage = 'static/home_default.png'
  const logo = '/static/aia-tth-logo-white.png'

  const isSecondaryPage =
    router.asPath === '/kr/onebillion' || router.asPath === '/kr/partnership'

  return (
    <header sx={styles.header}>
      <Box
        sx={
          isSecondaryPage ? styles.logoSecondaryContainer : styles.logoContainer
        }
      >
        <Image src={logo} onClick={() => redirectToPage(router, locale, '/')} />
      </Box>
      <Box sx={styles.menuContainer}>
        <NavBar navItems={sideMenu} locale={locale} />
      </Box>
      <Box sx={styles.imageContainer}>
        <Box sx={isSecondaryPage ? styles.blueOverlay : styles.overlay} />
        <Image
          sx={styles.headerImage}
          {...props}
          src={
            layout?.carrousel
              ? layout?.carrousel[0]?.image
              : layout?.backgroundImage || defaultImage
          }
        />
      </Box>
      <Box sx={styles.titleContainer}>
        <Heading
          as="h2"
          sx={{ ...styles.title, variant: `text.headerTopTitle` }}
        >
          {layout?.topTitle}
        </Heading>
        <Heading
          as="h2"
          sx={{ ...styles.bottomTitle, variant: `text.headerBottomTitle` }}
        >
          {layout?.bottomTitle}
        </Heading>
      </Box>
    </header>
  )
}

export default Header
